module.exports = __webpack_public_path__ + "img/questionBankTitles.3cd2c9de.svg";